import { IExecutionOptions, IQueryContext } from '../models/query';
import { Query } from './Query';
import { IQueryOptionsDataset } from '../models/query/options';
import { BaseQuery } from './BaseQuery';
import { IDatasetExecuteResponse, QueryOutputType } from '../models/api/dataset';
import { ConditionalHelper } from '../helpers/ConditionalHelper';
import { isNullOrUndefined } from '../utils/typeChecks';

export class DatasetQuery extends BaseQuery<IQueryOptionsDataset> {
	getOptions(): IQueryOptionsDataset {
		const { key, index, collectionItemConditional, options = {} } = this.queryOptions;
		return {
			key,
			index,
			collectionItemConditional,
			...(options.dataset || {}),
		} as any;
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const context = Query.getContext(executionOptions, this.queryOptions);
		const { datasetKey, queryKey, key, index, collectionItemConditional, returnFullQuery = false } = this.options;
		const dataset = this.getDataset(context, datasetKey);
		if (dataset) {
			const query = dataset.queries.find(query => query.key === queryKey);
			if (query) {
				let { results, type } = query;
				if (Array.isArray(results) && results.length > 0) {
					if (key && type === QueryOutputType.arrayOfObjects) {
						results = (results as Record<string, any>[]).map(r => r[key]);
					}
					if (!isNullOrUndefined(index) && index < results.length) {
						results = results[index] as any;
					}
					else if (collectionItemConditional) {
						const conditionalHelper = new ConditionalHelper({ conditions: [] }, this.translationHelper);
						results = results.filter(item => conditionalHelper.matches(item, collectionItemConditional, executionOptions)) as any;
					}
					if (!returnFullQuery) {
						return results as any;
					}
				}
				return query as any;
			}
		}
	}
	
	getDataset(context: IQueryContext, datasetKey: string): IDatasetExecuteResponse | undefined {
		if (context && context.datasets) {
			return context.datasets[datasetKey];
		}
	}
}